import React from 'react';

import { Alert } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import PropertyConstants from '../../../constants/PropertyConstants';

import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type Props = {
  universal: { partialMessages: Array<PartialMessageProps> };
  syndicationStatus: string;
};

const ListingStatusBanner = ({ universal, syndicationStatus = '' }: Props) => {
  if (
    !universal ||
    universal.partialMessages.length < 1 ||
    syndicationStatus === PropertyConstants.SYNDICATION_OVERVIEW_STATUS.INACTIVE
  ) {
    return null;
  }

  return (
    <Alert tone="info" css={{ marginBottom: '600' }}>
      <PartialMessage partialMessages={universal.partialMessages} />
    </Alert>
  );
};

export { ListingStatusBanner };
export default ListingStatusBanner;
